import React from "react";
import { Chip } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const StatusChip = ({ active }) => (
    <Chip
        icon={active ? <CheckCircleIcon sx={{ fontSize: 14 }} /> : <CancelIcon sx={{ fontSize: 14 }} />}
        label={active ? "Actif" : "Inactif"}
        size="small"
        sx={{
            fontWeight: 600,
            fontSize: 11,
            bgcolor: active ? "#E8FAF0" : "#FFF0F0",
            color: active ? "#059669" : "#DC2626",
            border: `1px solid ${active ? "#059669" : "#DC2626"}20`,
            "& .MuiChip-icon": { color: active ? "#059669" : "#DC2626" },
        }}
    />
);

export default StatusChip;
